import logo from "@/assets/img/landing/logo.webp"
import { cn } from "@/lib/utils"

interface LandingLogoProps {
  /** `sm` for the header, `lg` for the outro hero. */
  size?: "sm" | "lg"
  className?: string
}

/** "Live Palmistry" wordmark: rounded app icon + two-line Kalnia label. */
export function LandingLogo({ size = "sm", className }: LandingLogoProps) {
  const lg = size === "lg"
  return (
    <div
      data-slot="landing-logo"
      className={cn("flex items-center", lg ? "gap-4" : "gap-2", className)}
    >
      <img
        src={logo}
        alt="Live Palmistry"
        className={cn("shrink-0 rounded-[8px] object-cover", lg ? "size-16" : "size-8")}
      />
      <p
        className={cn(
          "font-display font-medium leading-[1.05] text-purple-light",
          lg ? "text-2xl" : "text-xs",
        )}
      >
        Live
        <br />
        Palmistry
      </p>
    </div>
  )
}
